//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalendarFilters",
  computed: {
    ...mapGetters({
      filtersType: 'schedule-calendar/filtersType',
    }),
    types() {
      return [
        'weekend',
        'next-week',
        'first-month',
        'second-month',
        'third-month',
      ]
    }
  },
  methods: {
    captionText(type) {
      switch (type) {
        case 'first-month':
          return this.$moment().format('MMMM')
        case'second-month':
          return this.$moment().add(1, 'months').format('MMMM')
        case'third-month':
          return this.$moment().add(2, 'months').format('MMMM')
        case'weekend':
          return this.$t(`components.schedule-calendar.filters.${type}`)
        case'next-week':
          return this.$t(`components.schedule-calendar.filters.${type}`)
        default:
          return this.$moment().format('MMMM')
      }
    }
  }
}
